export default "__VITE_ASSET__6df67827__"